import { memo } from 'react'

import { Button, Text } from '@cash-me/react-components'

import { Infos } from 'components/general-styles/General'
import { Col, Grid } from 'components/grid'
import { Logo } from 'components/logo'
import useWindowSize from 'hooks/useWindowSize'

import * as S from './styles'

type Props = {
  onClick: () => void
  highlightColor?: string
  highlightedTitle?: string
  title?: string
  ctaAriaLabel?: string
  ctaLabel?: string
  scrollToHeroOnDesktop?: boolean
  variant?: 'default' | 'contrast'
  textSize?: 'body1' | 'bodySmall'
}

export const BestChoice = memo(
  ({
    onClick,
    highlightColor = 'var(--colors-pink-text-contrast)',
    highlightedTitle = 'é a sua melhor escolha!',
    title = 'A CashMe é a sua melhor escolha!',
    ctaAriaLabel = 'Simular empréstimo com a CashMe agora',
    ctaLabel = 'Solicitar uma simulação',
    scrollToHeroOnDesktop = true,
    variant = 'default',
    textSize = 'body1'
  }: Props) => {
    const { isTablet } = useWindowSize()
    const [titlePrefix, titleSuffix = ''] = title.split(highlightedTitle)
    const isContrast = variant === 'contrast'
    const textColor = isContrast ? 'var(--colors-neutral-text-contrast-default)' : 'var(--colors-neutral-text-default)'

    const handleClick =
      isTablet && scrollToHeroOnDesktop
        ? () => {
            document.querySelector('#hero-section')?.scrollIntoView({
              behavior: 'smooth'
            })
          }
        : onClick

    return (
      <S.Section
        $bg={isContrast ? 'contrast' : undefined}
        $variant={variant}
        $textSize={textSize}
        aria-labelledby="best-choice-title"
      >
        <Grid col={{ phone: 1, tablet: 2 }}>
          <Col col={{ tablet: 1, desktop: 5 }} start={{ desktop: 2 }}>
            <Text
              id="best-choice-title"
              as="h2"
              aria-label={title}
              size="heading2"
              weight="medium"
              color={textColor}
            >
              {titlePrefix}
              <Text as="span" size="heading2" weight="medium" color={highlightColor}>
                {highlightedTitle}
              </Text>
              {titleSuffix}
            </Text>
            <Infos>
              <Text size={textSize} color={textColor}>
                A CashMe é a fintech do grupo Cyrela! Somos especialistas em Empréstimo com Garantia de Imóvel e atuamos
                em território nacional.
              </Text>
              <Text size={textSize} color={textColor}>
                Com uma operação 100% digital, liberamos crédito rápido e personalizado por especialistas financeiros
                para impulsionar projetos de vida de milhares de brasileiros!
              </Text>
              <Text size={textSize} color={textColor}>
                De maneira inovadora, utilizamos a tecnologia para oferecer uma experiência descomplicada, protegendo não
                só seus dados, mas também seus sonhos. Não abrimos mão da ética e da transparência para garantir um
                crédito seguro para você!
              </Text>
            </Infos>
            {isTablet ? (
              <Button aria-label={ctaAriaLabel} size="lg" onClick={handleClick} variants="text-only">
                {ctaLabel}
              </Button>
            ) : null}
          </Col>
          <Col col={{ tablet: 1, desktop: 4 }} start={{ desktop: 8 }}>
            <S.WrapperLogos>
              <S.LogoImage $variant="cashme" role="img" aria-label="CashMe">
                <Logo type={isContrast ? 'CashmeFooter' : 'Cashme'} width={18.75} height={4} />
              </S.LogoImage>
              <Text size="heading5" as="span">
                Empresa do grupo
              </Text>
              <S.LogoImage $variant="cyrela" role="img" aria-label="Cyrela">
                <Logo type="Cyrela" width={14.06} height={3} />
              </S.LogoImage>
              {!isTablet ? (
                <Button aria-label={ctaAriaLabel} size="lg" onClick={handleClick} variants="text-only">
                  {ctaLabel}
                </Button>
              ) : null}
            </S.WrapperLogos>
          </Col>
        </Grid>
      </S.Section>
    )
  }
)

BestChoice.displayName = 'BestChoice'

export default BestChoice
